import { render, staticRenderFns } from "./ShowMoreText.vue?vue&type=template&id=a3fd926a&scoped=true&lang=pug&"
import script from "./ShowMoreText.vue?vue&type=script&lang=js&"
export * from "./ShowMoreText.vue?vue&type=script&lang=js&"
import style0 from "./ShowMoreText.vue?vue&type=style&index=0&id=a3fd926a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fd926a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
